import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Button, message, Avatar, Divider, List, Upload,Typography } from 'antd';
import { apiRequest } from '../../../service/apiRequest';
import { showSuccess , showError } from '../../../components/errorHandler';

const { Text, Link } = Typography;
const THREADS_PER_PAGE = 10;
interface File {
    file_path: string;
    file_name: string;
}
interface Thread {
    thread_id: number;
    thread_description: string;
    thread_created_on: string;
    user_name: string;
    files: File[];
}

interface ThreadModalProps {
    ticketId: number | null;
    onClose: () => void;
    visible: boolean;
}

const ThreadModal: React.FC<ThreadModalProps> = ({ ticketId, onClose, visible }) => {
    const [threads, setThreads] = useState<Thread[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [isReplying, setIsReplying] = useState(false);
    // const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [fileList, setFileList] = useState<any[]>([]);

    const [visibleThreads, setVisibleThreads] = useState<Thread[]>([]);
    const [form] = Form.useForm();
    // const getMoreThreads = () => {
    //     if (loadingMore) return;

    //     setLoadingMore(true);
    //     setTimeout(() => {
    //         const nextLength = visibleThreads.length + THREADS_PER_PAGE;
    //         const nextThreads = threads.slice(0, nextLength);

    //         setVisibleThreads(nextThreads);
    //         setHasMore(nextThreads.length < threads.length);
    //         setLoadingMore(false);
    //     }, 500); // simulate loading delay
    // };
    const getThreads = async () => {
        try {
            if (!ticketId) return;

            const response = await apiRequest({
                method: 'get',
                url: `threads/${ticketId}`,
            });
            setThreads(response);
        } catch (error) {
            showError('Failed to load threads.');
        }
    };

    useEffect(() => {
        if (ticketId && visible) {
            getThreads();
            // setVisibleThreads(threads.slice(0, THREADS_PER_PAGE));
            // setHasMore(threads.length > THREADS_PER_PAGE);
        }
    }, [ticketId, visible]);

    const handleReplyClick = () => {
        setIsReplying(true);
    };

    const handleAdd = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const formData = new FormData();
            formData.append('ticket_id', ticketId?.toString() ?? '');
            formData.append('thread_description', values.description);

            fileList.forEach((file) => {
                formData.append('attachments', file.originFileObj); // backend expects 'attachments' array
            });
            const response = await apiRequest({
                method: 'post',
                url: '/add-threads',
                data: formData,
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
            });

            showSuccess(response.message || 'Thread added successfully');
            form.resetFields();
            setIsReplying(false);
            setFileList([]);
            getThreads();
        } catch (error: any) {
            showError(error.message || 'Failed to add thread');
        } finally {
            setLoading(false);
        }
    };

    const handleCancelReply = () => {
        form.resetFields();
        setIsReplying(false);
    };

    const handleCancel = () => {
        form.resetFields();
        setThreads([]);
        onClose();
        setIsReplying(false);
    };

    return (
        <Modal
            title="View Thread"
            open={visible}
            onCancel={handleCancel}
            footer={
                isReplying ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <Form form={form} layout="vertical">
                            <Form.Item
                                name="description"
                                label="Description"
                                rules={[{ required: true, message: 'Description is required.' }]}
                            >
                                <Input.TextArea rows={3} placeholder="Write description here..." />
                            </Form.Item>
                            <Form.Item label="Attachments" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <Upload
                                    fileList={fileList}
                                    onChange={({ fileList }) => setFileList(fileList)}
                                    beforeUpload={() => false} // prevent automatic upload
                                    multiple
                                    maxCount={5}
                                >
                                    <Button>Click to Upload</Button>
                                </Upload>
                            </Form.Item>
                        </Form>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                            <Button onClick={handleCancelReply}>Cancel</Button>
                            <Button type="primary" loading={loading} onClick={handleAdd}>
                                Add Thread
                            </Button>
                        </div>
                    </div>
                ) : (
                    <Button type="primary" onClick={handleReplyClick}>
                        Thread Reply
                    </Button>
                )
            }
            width="80%"
            style={{ top: 30 }}
            bodyStyle={{
                padding: '16px 0px 0 0px ',
                overflowY: 'auto',
                margin: 0,
                maxHeight: 'calc(100vh - 176px)',
            }}
        >

            <List
                dataSource={threads}
                bordered
                renderItem={(thread) => (
                    <List.Item key={thread.thread_id}>
                        <List.Item.Meta
                            avatar={<Avatar src={'https://avatars.githubusercontent.com/u/67627511'} />}
                            title={
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span><strong style={{textTransform:'capitalize'}}>{thread.user_name}</strong></span>
                                    <small style={{ color: '#888', whiteSpace: 'nowrap' }}>
                                        {new Intl.DateTimeFormat('en-IN', {
                                            dateStyle: 'medium',
                                            timeStyle: 'short',
                                            timeZone: 'Asia/Kolkata',
                                        }).format(new Date(thread.thread_created_on))}
                                    </small>
                                </div>
                            }
                            description={
                                <>
                                    <Text>{thread.thread_description}</Text>
                                    {thread.files && thread.files.length > 0 && (
                                        <div style={{ marginTop: 8 }}>
                                            <Text strong>Attachments:</Text>
                                            <ul style={{ paddingLeft: 20 }}>
                                                {thread.files.map((file, index) => (
                                                    <li key={index}>
                                                        <Link
                                                            href={`${process.env.REACT_APP_FILE_URL}uploads/tickets//${file.file_path}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {file.file_name} {/* Render the file name */}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </>
                            }                            
                        />
                    </List.Item>
                )}
                style={{ marginBottom: 16 }}
            />
        </Modal>
    );
};

export default ThreadModal;
